import { IcLoadingIndicator } from "@ukic/react";

/** Centred loading indicator for page/section busy states. */
export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="hl-center-pad">
      <IcLoadingIndicator label={label} />
    </div>
  );
}
